export const COOKIES_KEYS = {
	UUID: 'uuid',
	SETTINGS: 'cookies_settings',
	GPC_SIGNAL: 'gpc_signal',
	RND_FB_PIXEL: 'cookies_rnd_fb_pixel',
	UETMSCLKID: '_uetmsclkid',
	FBCLID: 'fbclid',
	TIER_TEST: 'tier_test',
	PACK_TEST: 'pack_test',
	M_TEST: 'm_test',
	TEST_VARIANT: 'onboarding_test_variant',
	TEST_NAME: 'onboarding_test_name',
	VERSION_NAME: 'onboarding_version_name',
	LOCALE: 'locale',
	SPLIT_TESTS: 'liftapp_split_tests',
	TRIAL_AVAILABLE: 'trialAvailable',
} as const;
